import "core-js/modules/es.string.link";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from 'react';
import classnames from 'classnames';
import Text from '../../Typography/Text';
import Icon from '../Icon';
import styles from './CounterIcon.scss';

function CounterIcon(_ref) {
  var _classnames;

  var count = _ref.count,
      icon = _ref.icon,
      link = _ref.link,
      className = _ref.className,
      isActive = _ref.isActive,
      onClick = _ref.onClick;
  var isLink = Boolean(link);
  var isClickable = isLink || Boolean(onClick);
  var Tag = 'div';

  if (isLink) {
    Tag = 'a';
  } else if (isClickable) {
    Tag = 'button';
  }

  return /*#__PURE__*/React.createElement(Tag, {
    href: link,
    type: isLink ? 'button' : undefined,
    onClick: onClick,
    className: classnames(styles.root, className, (_classnames = {}, _defineProperty(_classnames, styles.isActive, isActive), _defineProperty(_classnames, styles.isClickable, isClickable), _classnames))
  }, /*#__PURE__*/React.createElement(Icon, {
    name: icon,
    color: isActive ? 'accent' : 'icon'
  }), /*#__PURE__*/React.createElement(Text, {
    color: "label",
    size: "small",
    className: styles.counter
  }, count));
}

CounterIcon.defaultProps = {
  link: undefined,
  className: undefined,
  isActive: false,
  onClick: undefined
};
export default CounterIcon;